/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flash-icon': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data:
      '<path pid="0" d="M9.667 0L8 6.4h5L6.75 16H5.5l1.667-6.4H3L4.667 0h5z" _fill="#A363FF"/>'
  }
})
